import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme, CheckBox } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import { loadJV } from './functions/loadPurchaseJv';

import LoadPurchaseJv from './functions/loadPurchaseJv';
import SupplierForm from '../supplier/supplierForm';
import SimpleForm from '../../inventoryTab/product/simple/simpleForm';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './cards/invoiceInfo';
import InvoiceAccount from './cards/invoiceAccount';
import InvoiceCart from './cards/invoiceCart';
import InvoiceCharge from './cards/invoiceCharge';
import InvoiceTotal from './cards/invoiceTotal';
import InvoicePayment from './cards/invoicePayment';

import InvoiceJv from '../../components/journalVoucher/invoiceJv';




const PurchaseForm = (props) => {

    const { api, userData, settingData, warehouseData, companyId, defaultCurrency, rateToMainCurrency, showSupplierModal, openAddSupplierModal,
        productData, refData, branchData, salableData, yearId, sessionId, secondaryCurrency, rateMainToSecondaryCurrency,
        currencyData, formLanguages } = useContext(DataContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const createdBy = parseInt(userData.id);
    const cashAccountId = userRole.cashAccountId;

    const { showModal, toggleModal, refreshTable, isOrder, isDebit, idRow, type } = props;

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [cart, setCart] = useState([])

    const [journalVoucher, setJournalVoucher] = useState({});
    const [charges, setCharges] = useState([])
    const [transactions, setTransactions] = useState([])
    const [allocateInvoice, setAllocateInvoice] = useState(false)

    const [showAddProductModal, setShowAddProductModal] = useState(false);


    const openAddProductModal = (e) => {
        setShowAddProductModal(!showAddProductModal);
    }

    const netCharges = charges.reduce((sum, item) => sum + parseFloat(item.total), 0);

    const subTotal = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.totalCost), 0);
    const cartDiscounts = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.costDiscountAmount), 0);

    let discountAmount;
    if (journalVoucher.discountType == 'amount') {
        discountAmount = journalVoucher.discountAmount;
    } else {
        discountAmount = (journalVoucher.discountPercentage / 100) * (subTotal);
    }

    let discountPercentage;
    if (journalVoucher.discountType == 'percentage') {
        discountPercentage = journalVoucher.discountPercentage;
    } else {
        discountPercentage = (discountAmount / (subTotal)) * 100 || 0;
    }

    const totalDiscounts = parseFloat(discountAmount);
    const total = subTotal - totalDiscounts;

    const vate = cart.reduce((sum, item) => sum + parseFloat(item.vatAmount), 0);
    const vat = vate - (vate * (journalVoucher.discountPercentage / 100)) || 0;

    const netTotal = parseFloat(total) + parseFloat(vat);


    const today = new Date().toISOString().split('T')[0];

    const selectedCurrency = useMemo(() => {
        return currencyData?.find(option => option.id === journalVoucher.currencyId);
    }, [currencyData, journalVoucher.currencyId]);


    const cartItem = {
        accountId: '',
        index: 0,

        quantity: 1,
        freeQuantity: 0,
        netQuantity: 1,

        cost: 0,
        netCost: 0,
        costDiscountPercentage: 0,
        costDiscountAmount: 0,
        totalCost: 0,

        details: '',

        unitName: '',
        unitQuantity: '',

        vatPercentage: 0,
        vatAmount: 0,
        productId: '',
    };

    // idRow Change
    useEffect(() => {
        if (!isLoading) {
            setCartAndUnits();
            setTransactions(idRow?.transactions || []);
            setCharges(idRow?.charges || []);

            setJournalVoucher(
                {
                    createdBy: createdBy,
                    sessionId: sessionId,
                    companyId: companyId,
                    yearId: yearId,
                    accountId: idRow?.accountId || null,
                    cashAccountId: idRow?.cashAccountId || cashAccountId,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: type,
                    totalDebit: idRow?.totalDebit || 0,
                    totalCredit: idRow?.totalCredit || 0,
                    secondaryTotalDebit: idRow?.secondaryTotalDebit || 0,
                    secondaryTotalCredit: idRow?.secondaryTotalCredit || 0,
                    details: idRow?.details || '',
                    paymentType: idRow?.paymentType || 'cash',
                    downPayment: idRow?.downPayment || 0,
                    isDebit: idRow?.isDebit || isDebit,
                    isOrder: idRow?.isOrder || isOrder,
                    discountType: idRow?.discountType || 'percentage',
                    discountPercentage: idRow?.discountPercentage || 0,
                    discountAmount: idRow?.discountAmount || 0,
                    currencyId: idRow?.currencyId || defaultCurrency?.id,
                    rate: idRow?.rate || defaultCurrency?.rate,

                    isChargeAllocated: idRow?.isChargeAllocated || false,

                    purchaseInvoiceId: idRow?.purchaseInvoiceId || null,

                    warehouseId: idRow?.warehouseId || userRole?.warehouseId,
                    projectId: idRow?.projectId || null,
                    branchId: idRow?.branchId || userRole?.branchId,
                }
            )
        }
    }, [isLoading]);

    const setCartAndUnits = () => {
        const updatedCart = idRow?.cart ? [...idRow?.cart] : [];
        for (const item of updatedCart) {
            const product = salableData.find(e => e.id == item.productId);
            const units = product?.units || [];
            item.units = units;
        }
        setCart(updatedCart || [cartItem])
    }

    // change totalDebit and totalCredit
    useEffect(() => {

        const totalDebit = rateToMainCurrency(selectedCurrency, netTotal);
        const totalCredit = rateToMainCurrency(selectedCurrency, netTotal);

        setJournalVoucher((prev) => ({
            ...prev,
            debit: netTotal,
            credit: netTotal,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalCredit: rateMainToSecondaryCurrency(totalDebit),
            secondaryTotalDebit: rateMainToSecondaryCurrency(totalCredit),
        }));

    }, [netTotal]);

    useEffect(() => {
        if (showModal) {
            fetchData();
        } else {
            setIsLoading(true);
        }
    }, [showModal]);

    const fetchData = async () => {
        try {
            const dataArray = ['auxAccount', 'supplierAccount', 'warehouse', 'branch', 'project', 'currency', 'salable', 'setting', 'purchaseInvoice']
            await refData(dataArray, companyId, yearId);

            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };





    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = document.getElementById('purchaseForm');

        if (form.checkValidity() === false) {
            return;
        }

        if (cart.length < 1) {
            toast.error('cart is empty')
            return;
        }

        if (transactions.length < 2) {
            toast.error('you need at least 2 transactions')
            return;
        }


        setLoadingEffect(true);


        const data = {
            userId: userData.id,
            sessionId,
            jvId: idRow?.id,
            transactions,
            journalVoucher,
            cart,
            charges,
        }

        const operation = idRow ? 'edit' : 'add '
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('purchaseForm');
        form.reset();
        setCart([cartItem]);
        setTransactions([]);
        setCharges([]);
        refreshTable();
    }



    return (
        <>
            <Modal show={showModal} onHide={toggleModal} fullscreen={true}>

                <Modal.Header closeButton>
                    <Modal.Title>{idRow ? formLanguages.Edit : formLanguages.Add}{type}</Modal.Title>
                </Modal.Header>

                {isLoading &&
                    <div style={{ height: '20vh' }}>
                        <Loader />
                    </div>
                }

                {!isLoading &&
                    <Modal.Body style={{ backgroundColor: '#f0f2f5' }}>
                        <Form validated={validated} id={'purchaseForm'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >

                            <Row className="mb-4">
                                <Col>
                                    <Card title={formLanguages.Supplier} bordered={false}>
                                        <InvoiceAccount
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                            type={type}
                                        />
                                    </Card>
                                </Col>

                                <Col>

                                    <Card title={formLanguages.Details} bordered={false}>
                                        <InvoiceInfo
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                            setCart={setCart}
                                            cartItem={cartItem}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col>
                                    <Card title={formLanguages.Products} bordered={false}>
                                        <InvoiceCart
                                            cart={cart}
                                            setCart={setCart}
                                            cartItem={cartItem}
                                            selectedCurrency={selectedCurrency}
                                            setJournalVoucher={setJournalVoucher}
                                            journalVoucher={journalVoucher}
                                            openAddProductModal={openAddProductModal}
                                            idRow={idRow}
                                            netCharges={netCharges}
                                            setAllocateInvoice={setAllocateInvoice}
                                            allocateInvoice={allocateInvoice}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                            <Row className="mb-4">
                                <Col>
                                    <Space direction="vertical" size="large" style={{ width: "100%" }}>
                                        <Card title={formLanguages.Charges} bordered={false}>
                                            <InvoiceCharge
                                                charges={charges}
                                                setCharges={setCharges}
                                                selectedCurrency={selectedCurrency}
                                                validated={validated}
                                                setJournalVoucher={setJournalVoucher}
                                                journalVoucher={journalVoucher}
                                            />
                                        </Card>
                                        <Card title={formLanguages.Payment} bordered={false}>
                                            <InvoicePayment
                                                journalVoucher={journalVoucher}
                                                setJournalVoucher={setJournalVoucher}
                                                validated={validated}
                                            />
                                        </Card>
                                    </Space>
                                </Col>
                                <Col>
                                    <Card title={formLanguages.Total} bordered={false}>
                                        <InvoiceTotal
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            subTotal={subTotal}
                                            cartDiscounts={cartDiscounts}
                                            discountPercentage={discountPercentage}
                                            discountAmount={discountAmount}
                                            total={total}
                                            vat={vat}
                                            netTotal={netTotal}
                                            selectedCurrency={selectedCurrency}
                                        />
                                    </Card>
                                </Col>
                            </Row>



                            <Row className="mb-4">
                                <Col>
                                    <Card title={formLanguages.JournalVoucher} bordered={false}>
                                        <InvoiceJv
                                            transactions={transactions}
                                            selectedCurrency={selectedCurrency}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                            <div style={{ textAlign: 'right' }}>
                                <Button type="primary" loading={loadingEffect} htmlType="submit"
                                    onClick={() => setValidated(true)}
                                    style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>{formLanguages.Save}</Button>
                            </div>


                        </Form>



                    </Modal.Body>
                }



            </Modal >

            <LoadPurchaseJv
                setTransactions={setTransactions}
                cart={cart}
                journalVoucher={journalVoucher}
                selectedCurrency={selectedCurrency}
                netTotal={netTotal}
                totalDiscounts={totalDiscounts}
                vat={vat}
                subTotal={subTotal}
            />




        </>
    )
}


export default PurchaseForm;